// extracted by mini-css-extract-plugin
export default {"parkingSpaces":"styles_parkingSpaces__5BvsQ","holder":"styles_holder__pL0Pb","count":"styles_count__arY9v","addWrapper":"styles_addWrapper__bl9qb"};